import React from 'react';
import { Typography, Divider, Card, Space } from 'antd';

const { Title, Paragraph, Text } = Typography;

const PrivacyPolicy: React.FC = () => {
  return (
    <div className='container mx-auto py-12 px-4'>
      <Title level={2} className='text-center mb-8'>
        Privacy Policy
      </Title>

      <Card className='mb-8'>
        <Space direction='vertical' className='w-full' size='large'>
          <div>
            <Title level={4}>Introduction</Title>
            <Paragraph>
              At Fruit Shop, we are committed to protecting your privacy and
              ensuring the security of your personal information. This Privacy
              Policy outlines how we collect, use, disclose, and safeguard your
              information when you visit our website or make purchases through
              our platform.
            </Paragraph>
            <Paragraph>
              By using our services, you agree to the terms outlined in this
              Privacy Policy. We may update this policy from time to time, so
              please review it periodically.
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>Information We Collect</Title>
            <Paragraph>
              We collect the following types of information:
            </Paragraph>
            <Paragraph>
              <Text strong>• Personal Information:</Text> Name, email address,
              phone number, billing and shipping addresses.
            </Paragraph>
            <Paragraph>
              <Text strong>• Payment Information:</Text> Credit card details,
              payment method information (processed securely through our payment
              processors).
            </Paragraph>
            <Paragraph>
              <Text strong>• Order Information:</Text> Products purchased, order
              history, delivery preferences.
            </Paragraph>
            <Paragraph>
              <Text strong>• Technical Information:</Text> IP address, browser
              type, device information, cookies, and usage data.
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>How We Use Your Information</Title>
            <Paragraph>
              We use your information for the following purposes:
            </Paragraph>
            <Paragraph>
              <Text strong>• Process and fulfill your orders</Text> including
              sending order confirmations and delivery updates.
            </Paragraph>
            <Paragraph>
              <Text strong>• Manage your account</Text> and provide customer
              support.
            </Paragraph>
            <Paragraph>
              <Text strong>• Improve our website</Text> and enhance user
              experience.
            </Paragraph>
            <Paragraph>
              <Text strong>• Send promotional offers</Text> and newsletters
              (with your consent).
            </Paragraph>
            <Paragraph>
              <Text strong>• Detect and prevent fraud</Text> or unauthorized
              access.
            </Paragraph>
            <Paragraph>
              <Text strong>• Comply with legal obligations</Text> and enforce
              our terms of service.
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>Information Sharing</Title>
            <Paragraph>We may share your information with:</Paragraph>
            <Paragraph>
              <Text strong>• Service Providers:</Text> Payment processors,
              delivery partners, and IT service providers who help us operate
              our business.
            </Paragraph>
            <Paragraph>
              <Text strong>• Legal Authorities:</Text> When required by law or
              to protect our rights and safety.
            </Paragraph>
            <Paragraph>
              We do not sell or rent your personal information to third parties
              for their marketing purposes.
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>Data Security</Title>
            <Paragraph>
              We implement appropriate technical and organizational measures to
              protect your personal information against unauthorized access,
              alteration, disclosure, or destruction. However, no method of
              transmission over the Internet or electronic storage is 100%
              secure, and we cannot guarantee absolute security.
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>Your Rights</Title>
            <Paragraph>
              Depending on your location, you may have the following rights:
            </Paragraph>
            <Paragraph>
              <Text strong>• Access and update</Text> your personal information.
            </Paragraph>
            <Paragraph>
              <Text strong>• Request deletion</Text> of your personal
              information.
            </Paragraph>
            <Paragraph>
              <Text strong>• Object to processing</Text> of your personal
              information.
            </Paragraph>
            <Paragraph>
              <Text strong>• Withdraw consent</Text> for certain data processing
              activities.
            </Paragraph>
            <Paragraph>
              To exercise these rights, please contact us using the information
              provided at the end of this policy.
            </Paragraph>
          </div>
        </Space>
      </Card>

      <div className='text-center'>
        <Paragraph type='secondary'>
          This privacy policy was last updated on October 1, 2023. We reserve
          the right to make changes to our privacy policy at any time.
        </Paragraph>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
